import qs from 'qs'
import { HALApiService } from './hal-api.service'
import { ItemsService } from './base-service'

export const storageItemsService = new ItemsService('/storage/item-service', HALApiService, qs)
